import { ca } from '@cian/analytics';

import { IBrokerAnalyticsUser } from '../../../types/newbuildingBroker';

export const trackFallbackModalRetryClick = (user: IBrokerAnalyticsUser) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'Click',
    label: 'BrokerDealPopUpRetry',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        is_link: false,
      },
    },
    user,
    useLastProducts: true,
  });
};
